// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"2218cdee","244":"e399b631","344":"81d0ee64","354":"26ac3027","936":"0c6291e0"}[chunkId] + ".chunk.js";
};